import { Link as RouterLink } from 'react-router-dom';
import Icons from 'assets/icons';

interface SeeAllButtonProps {
  route: string;
  contentType?: string;
  customClass?: string;
}

const SeeAllButton = ({
  route,
  contentType,
  customClass = '',
}: SeeAllButtonProps): React.JSX.Element => (
  <RouterLink
    to={route}
    className={`flex font-semibold items-center gap-1 hover:gap-2 text-blue-700 hover:text-navy-800 w-fit my-6 transition-all ${customClass}`}
  >
    <div>See all {contentType}</div>
    <Icons.Arrow customClass="h-4 w-4 mt-1" />
  </RouterLink>
);

export default SeeAllButton;
